import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME } from '../config/branding';

const Footer = () => {
  return (
    <>
      {/* Footer */}
      <footer className="bg-white dark:bg-dark-bg-secondary py-16 border-t border-gray-100 dark:border-dark-border">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            {/* Brand Section */}
            <div className="md:col-span-1">
              <div className="flex items-center space-x-2 mb-6">
                <img 
                  src="/logo_clear_back.png" 
                  alt={`${APP_NAME} Logo`} 
                  width="32" 
                  height="32" 
                  className="object-contain"
                />
                <span className="text-2xl font-bold text-gray-900 dark:text-dark-text-primary">{APP_NAME}</span>
              </div>
              <p className="text-gray-600 dark:text-dark-text-secondary leading-relaxed mb-6">
                Recover lost revenue from no-shows and unlock growth with automated vaccine reminders and preventive care campaigns. Practices see $100k+ in recovered revenue annually.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-dark-text-primary mb-4">Quick Links</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/about" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/pricing" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/docs" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    Docs
                  </Link>
                </li>
                <li>
                  <Link to="/faq" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            {/* Browse Practices */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-dark-text-primary mb-4">Browse Practices</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/practices" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    All Practices
                  </Link>
                </li>
                <li>
                  <Link to="/practice/CA" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    California
                  </Link>
                </li>
                <li>
                  <Link to="/practice/AZ" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    Arizona
                  </Link>
                </li>
                <li>
                  <Link to="/practice/AR" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    Arkansas
                  </Link>
                </li>
                <li>
                  <Link to="/practice/AL" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    Alabama
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal Pages */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-dark-text-primary mb-4">Legal</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/privacy" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>

            {/* Social Media */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-dark-text-primary mb-4">Social Media</h3>
              <ul className="space-y-3">
                <li>
                  <a 
                    href="https://linkedin.com/company/helppetai" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-600 dark:text-dark-text-secondary hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                  >
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Border */}
          <div className="border-t border-gray-200 dark:border-dark-border mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-500 dark:text-dark-text-muted text-sm">
                © 2026 HelpPetAI (d.b.a) is a service of Upcactus, Inc. All rights reserved.
              </p>
              <p className="text-gray-500 dark:text-dark-text-muted text-sm mt-4 md:mt-0">
                  Voice-First Platform • Made Proudly in 🇺🇸
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
